"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToggleSwitch = void 0;
var temas_frontend_1 = require("@aura/temas-frontend");
var react_1 = __importStar(require("react"));
var paragraphy_styles_1 = require("../../token/paragraphy/paragraphy.styles");
var tags_ga_1 = require("../../utils/tags-ga");
var styles_1 = require("./styles");
var ToggleSwitch = function (_a) {
    var id = _a.id, required = _a.required, message = _a.message, initialState = _a.initialState, hasError = _a.hasError, inputProps = _a.inputProps, errorMessage = _a.errorMessage, value = _a.value, disabled = _a.disabled, onClick = _a.onClick, onChange = _a.onChange, gaCategory = _a.gaCategory, gaAction = _a.gaAction, gaLabel = _a.gaLabel, gaEventType = _a.gaEventType, props = __rest(_a, ["id", "required", "message", "initialState", "hasError", "inputProps", "errorMessage", "value", "disabled", "onClick", "onChange", "gaCategory", "gaAction", "gaLabel", "gaEventType"]);
    var _b = (0, react_1.useState)(initialState), checked = _b[0], setChecked = _b[1];
    var toggle = function () { return setChecked(!checked); };
    var theme = (0, temas_frontend_1.useTheme)().theme;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(styles_1.ToggleSwitchSectionStyled, __assign({ id: id, checked: checked }, props),
            react_1.default.createElement(tags_ga_1.TagsGa, { category: gaCategory, action: gaAction, label: gaLabel, eventType: gaEventType },
                react_1.default.createElement(styles_1.ToggleSwitchChkbxStyled, __assign({ id: "toggleSwitch", type: "checkbox", required: required, checked: checked, onChange: function (event) {
                        toggle();
                        onChange && onChange(event);
                    }, value: value }, inputProps, { disabled: disabled }))),
            react_1.default.createElement(styles_1.ToggleSwitchSpanStyled, null),
            message && (react_1.default.createElement(styles_1.ToggleSwitchLabelStyled, { htmlFor: "toggleSwitch" },
                react_1.default.createElement(paragraphy_styles_1.PStyled, { p14: true, style: { margin: '0 0 0 16px' } }, message)))),
        hasError && errorMessage && (react_1.default.createElement(paragraphy_styles_1.PStyled, { small: true, color: theme.error, style: { marginTop: '8px', marginLeft: '16px', marginBottom: "".concat(hasError ? '16px' : '0') } }, errorMessage))));
};
exports.ToggleSwitch = ToggleSwitch;
